import { getAuth } from "firebase/auth";
import { getReadyAuthUser } from "~/utils/auth/waitForAuthReady";
import {
  ActionFunctionArgs,
  LoaderFunctionArgs,
  redirect,
  useRouteError,
} from "react-router-dom";
import { _ObjectType } from "~/types";
import { _AdvanceLeaseActionType, _CancelLeaseActionType } from "~/types/lease";
import { INTENTS, ENVS } from "~/utils";
import { S3ServiceLambda } from "~/services/s3";
import { FileModalContentLoaderType } from "~/components/FileModalView/FileModalView";
import * as APITypes from "~/API";

// TODO: Translate

export const TransactionTableDocsLoader = async ({
  request,
  params,
}: LoaderFunctionArgs): Promise<FileModalContentLoaderType | Response> => {
  const auth = getAuth();
  const user = await getReadyAuthUser();
  if (!user) redirect("/explore");

  const { searchParams } = new URL(request.url);
  const objectType = (searchParams.get("objectType") ||
    APITypes.EntityType.Transaction) as _ObjectType;
  const entityID = searchParams.get("entityID") || "";
  const disableActions = searchParams.get("disableActions") === "true";

  const files = await S3ServiceLambda.list({
    entityID,
    entityType: objectType,
  });

  return {
    files: files.data,
    objectType: objectType,
    entityID: entityID,
    disableActions: disableActions,
  };
};

export const TransactionTableDocsAction = async ({
  request,
  params,
}: ActionFunctionArgs) => {
  const formData = await request.formData();
  const intent = formData.get("intent");

  switch (intent) {
    case INTENTS._delete_file: {
      const key: string = formData.get("body") as string;
      const result = await S3ServiceLambda.remove({ key });
      return result;
    }
  }
  return null;
};
